// extracted by mini-css-extract-plugin
module.exports = {"heading":"CreateDataCluster_heading__35j2t","form":"CreateDataCluster_form__bzMv7"};